/* unplugin-vue-components disabled */import { render } from "./Ledger.vue?vue&type=template&id=5625aa92"
import script from "./Ledger.vue?vue&type=script&lang=js"
export * from "./Ledger.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__